import React from 'react'
import * as Styled from './TextualFormElement.styles'
import { InputProps } from './TextualFormElement.types'

export interface ComponentProps extends InputProps {
  /**
   * Node to insert before input element
   */
  prefixElement?: React.ReactNode
  /**
   * Node to insert after input element
   */
  suffixElement?: React.ReactNode
}

const InputBase: React.FC<ComponentProps> = React.forwardRef<HTMLInputElement, ComponentProps>((props, ref) => {
  const {
    disabled: isDisabled,
    isError,
    isCode,
    size = 'large',
    variant = 'default',
    onChange,
    onValueChange,
    prefixElement,
    suffixElement,
    className,
    ...otherProps
  } = props

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event)
    }
    if (onValueChange) {
      onValueChange(event.currentTarget.value)
    }
  }

  const pattern = otherProps?.pattern || (otherProps?.type === 'email' ? '[\\w]+[\\w.+-]*@[\\w-]{2,}(\\.[\\w-]{2,})?\\.[a-zA-Z]{2,}' : undefined)

  return (
    <Styled.Container isError={isError} size={size} variant={variant} isDisabled={isDisabled} isCode={isCode} className={className}>
      {prefixElement && <Styled.Prefix>{prefixElement}</Styled.Prefix>}
      <Styled.TextualFormElement onChange={handleChange} disabled={isDisabled} pattern={pattern} ref={ref} {...otherProps} />
      {suffixElement && <Styled.Suffix>{suffixElement}</Styled.Suffix>}
    </Styled.Container>
  )
})

InputBase.displayName = 'InputBase'
export default InputBase
